import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

function HoverImageComponent({ data }) {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [isHover, setIsHover] = useState({
    id: isMobile ? -1 : 0,
    hovered: isMobile ? false: true,
  });

  const handleMouseEnter = (id) => {
    setIsHover({ id: id, hovered: true });
  };

  useEffect(() => {
    getColor(isHover.id)
  }, [])

  const getColor = (id) => {
    if (isHover.id === id) {
      return "text-white"
    } else if (isHover.id === -1) {
      return "text-white"
    } else {
      return "text-gray-600"
    }
  }

  return (
    <>
      <div data-aos="fade-up"
        data-aos-offset="300"
        data-aos-easing="ease-in-out">
        {data.map((item, index) => {
          return <div key={item.title} className="flex justify-center">
            {isHover.id === index && <img src={item.leftImage} className="h-[93%] lg:block sm:block md:block xs:block hidden object-contain absolute top-5 left-4" alt={`leftImage-${index}`} />}
            <Link to="portfolio">
              <h1 onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={() =>
                  setIsHover({ id: -1, hovered: false })
                } className={`${getColor(index)} transitions lg:text-6xl text-4xl mb-2 hover:cursor-pointer`}>{item.title}</h1>
            </Link>
            {isHover.id === index && <img src={item.rightImage} className="h-[80%] lg:block sm:block md:block xs:block hidden object-contain absolute top-10 right-10" alt={`rightImage-${index}`} />}
          </div>
        })}
      </div>
    </>
  )
}

export default HoverImageComponent